// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__rt95m","tab":"Tabs_tab__64YiA","tabActive":"Tabs_tabActive__i4DBF"};